import mori from 'mori';
import {
  buildSpreadsheetData,
} from '../../../datacenter/app/js/reducers/dataReducer';
import {
  filterByTimeframe,
} from '../../../datacenter/app/js/services/dataFromOptions';
import getCombinedFilters
  from '../../../datacenter/app/js/services/getCombinedFilters';
import {
  REQUEST_DATA,
  RECEIVE_DATA,
} from '../config/types';
import updateData from '../services/updateData';
import actionTrigger from '../actions';

export default function loadData(data = {}, type = 'all') {
  return (dispatch) => {
    dispatch(actionTrigger(REQUEST_DATA));
    const state = {
      /**
       * buildSpreadsheetData outputs the following:
       *
       * {
       *   columns: Object,
       *   config: mori.hashMap(),
       *   distriubtionCount: Number,
       *   globalRules: {},
       *   globalSettings: {},
       *   immutableData: mori.hashMap(),
       *   immutableDataviews: [], // no idea why this isn't an immutable...
       *   immutableDistributions: mori.Vector(),
       *   immutableHeaders: mori.hashMap()
       *   timeframes: []
       * }
       */
      ...buildSpreadsheetData(data),
    };
    state.filteredData = filterByTimeframe(state, {});
    state.combinedFilters = getCombinedFilters(state, {});
    state.isMultiGeo = mori.get(state.combinedFilters[4], [1], false);
    state.type = type;

    const selectedDistribution =
      mori.toJs(mori.first(state.immutableDistributions)).slug;

    const { table, datamap } = updateData(state, {});

    dispatch(actionTrigger(RECEIVE_DATA, {
      sheetData: data,
      ...state,
      table,
      datamap,
      type,
      selectedDistribution,
    }));
  };
}



// WEBPACK FOOTER //
// ./app/actions/loadData.js